export enum RobotsFormFieldsNames {
  CONTENT = 'content',
}

export type TRobotsFormValues = {
  [RobotsFormFieldsNames.CONTENT]: string;
};
